export const ButtonUpdate = (props) => {
    const entity = props.entity;
    const id = props.id;
    return (
        <div className="button-update">
            <a className="button" href={`/admin/entity/update/${entity}/${id}`}>Update</a>
        </div>
    )
}